export default __webpack_public_path__ + "static/media/e11.542db701.jpg";